
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/headphones",
      function () {
        return require("private-next-pages/headphones/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/headphones"])
      });
    }
  